export default "__VITE_ASSET__DGLws_8c__"